import React, { Component } from 'react';
import './WizardProgressBar.css';
import FontAwesome from 'react-fontawesome';

const WizardProgressBar = (props) => {
    return (
        <div className="step-progress-bar">
            <div>
                <div className={props.step >= 1 ? 'circle done' : 'circle'}>
                    <FontAwesome name="user"/>
                </div>
                <div className={props.step >= 1 ? 'step-text done' : 'step-text' }>
                    פרטים אישיים
                </div>
            </div>

            <div className={props.step >= 2 ? 'seperator done' : 'seperator'}><hr/></div>

            <div>
                <div className={props.step >= 2 ? 'circle done' : 'circle'}>
                    <FontAwesome name="address-book"/>  
                </div>
                <div className={props.step >= 2 ? 'step-text done' : 'step-text' }>
                פרטי התקשרות
                </div>
            </div>

            
            <div className={props.step >= 3 ? 'seperator done' : 'seperator'}><hr/></div>
            
            <div>
                <div className={props.step >= 3 ? 'circle wide-font-awesome-adjustment done' : 'circle wide-font-awesome-adjustment'}>
                    <FontAwesome name="file-signature"/>
                </div>
                <div className={props.step >= 3 ? 'step-text done' : 'step-text' }>
                    חתימות ואישורים
                </div>
            </div>

            <div className={props.step >= 4 ? 'seperator short done' : 'seperator short'}><hr/></div>
            <div className={props.step >= 5 ? 'seperator short done' : 'seperator short'}><hr/></div>
            <div className={props.step >= 6 ? 'seperator short done' : 'seperator short'}><hr/></div>
            <div className={props.step >= 7 ? 'seperator short done' : 'seperator short'}><hr style={{width:'2.2rem'}}/></div>
            
            <div>
                <div className={props.step >= 7 ? 'circle done' : 'circle'}>
                    <FontAwesome name="check-double"/> {/* link */}
                </div>
                <div className={props.step >= 7 ? 'step-text done' : 'step-text' }>
                 {/* העלאת קבצים */}
                 סיום
                </div>
            </div>
        </div>
    );
  };
 
  export default WizardProgressBar;
            